// Home.js
import React, { useRef, useEffect, useState } from 'react';
import TopLeftMenuSimple from '../components/topLeftMenuSimple';
import TopRightMenu from '../components/topRightMenu';
import Scatterplot from '../components/scatterplot';
import LabelOverlay from '../components/labelOverlay';
import Loading from '../components/loading';
import Legends from '../components/legends';
import UserLegend from '../components/userLegend';
import LoadingHome from '../components/loadingHome';
// import PointHover from '../components/pointHover';
import { InfoComponent } from '../components/infoComponent';
import { isFirstVisit } from '../utils/firstVisit';
import arrayToColorDict from '../utils/array_to_color_dict'
import arrayToColorDictSourceBiomeNiceColors from '../utils/arrayToColorDictSourceBiomeNiceColors'
// import arrayToColorDictGeographicLocations from '../utils/arrayToColorDictGeographicLocationsNiceColors'
import arrayToContinuousNormalized from '../utils/arrayToContinuousNormalized'
import produceBiomeColorDict from '../utils/produceBiomeColorDict'
import arrayToColorDictFullBiome from '../utils/arrayToColorDictFullBiome'
import { fetchPoints, fetchCategoricalValues, fetchContinuousValues, fetchIDs, fetchUserData, fetchTotalBiomeCounts } from '../components/api';
import { useTheme } from '../theme/ThemeContext';


function Home() {
    // window.postOTU = postOTU;
    const [ids, setIDs] = useState([]);
    const [points, setPoints] = useState([]);
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingPoints, setloadingPoints] = useState(true);
    const [loadingColor, setloadingColor] = useState(true);
    const [loadingIds, setloadingIds] = useState(true);
    const [error, setError] = useState(null);
    const [scatterplot, setScatterplot] = useState(null);
    const [hoveredSampleInfo, setHoveredSampleInfo] = useState(null);
    const [selectedSampleInfo, setSelectedSampleInfo] = useState(null);
    const [scatterPointsCategory, setScatterPointsCategory] = useState('tsne');
    const [scatterColorCategory, setScatterColorCategory] = useState('source_biome');
    const [colorParentSelected, setColorParentSelected] = useState(["root:Environmental"]);
    const [colorDict, setColorDict] = useState({});
    const [possibleColorDict, setPossibleColorDict] = useState({});
    const [catigoricalResolution, setCatigoricalResolution] = useState(2);
    const [uniqueCategories, setUniqueCategories] = useState([]);
    const [colorsData, setColorsData] = useState([]);
    const [allBiomesSet, setAllBiomesSet] = useState([]);
    const [pendingSelection, setPendingSelection] = useState(null);
    const [currentPointsSelection, setCurrentPointsSelection] = useState(null);
    const [historyPointsSelectionStack, setHistoryPointsSelectionStack] = useState([]);
    const [futurePointsSelectionStack, setFuturePointsSelectionStack] = useState([]);
    const [userID, setUserID] = useState(null);
    const [basePoints, setBasePoints] = useState([]);
    const [userPoints, setUserPoints] = useState([]);
    const [highlightTaxon, setHighlightTaxon] = useState(null);
    const { theme } = useTheme();
    const continuousCategories = ['shannon_index_e', 'simpson_index', 'richnes', 'chao1', 'confidence', 'unknownness_score', 'temperature'];
    const [showWelcomeInfo, setShowWelcomeInfo] = useState(false);
    const [userPointsData, setUserPointsData] = useState(null);
    const [userColorMode, setUserColorMode] = useState('sample'); // 'sample' or 'confidence'
    const [totalBiomeCounts, setTotalBiomeCounts] = useState({});

    const [hoverVisible, setHoverVisible] = useState(false);
    const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
    const [hoverPointData, setHoverPointData] = useState(null);


    const isHistoryNavigationRef = useRef(false);

    const hasUserSamples = userPoints.length > 0;


    const fetchPointData = async (scatterPointsCategory) => {
        try {
            const pointsData = await fetchPoints(scatterPointsCategory);
            setBasePoints(pointsData);

            setloadingPoints(false);
        } catch (err) {
            setError('failed to fetch point data');
        }
    };

    const fetchColorData = async (scatterColorCategory) => {
        setloadingColor(true);
        try {
            if (continuousCategories.includes(scatterColorCategory)) {
                const data = await fetchContinuousValues(scatterColorCategory, userID);
                setColorsData(data);
            } else {
                const data = await fetchCategoricalValues(scatterColorCategory);
                setColorsData(data);
            }

            setloadingColor(false);
            setLoading(false);


        } catch (err) {
            setError('failed to fetch color data');
        }
    };

    const fetchIdData = async (id = 'run_ids') => {
        try {
            const idsData = await fetchIDs(id);
            setIDs(idsData);

            setSizes(Array(idsData.length).fill(0));
            setloadingIds(false);

        } catch (err) {
            setError('failed to fetch id data');
        }
    };


    const fetchUserSampleData = async (userID, scatterPointsCategory) => {
        try {

            // all user data is cleared before fetching new data
            setUserPoints([]);
            setUserPointsData(null);
            setPoints([...basePoints]);
            setColors(prev => prev.slice(0, basePoints.length));
            setSizes(prev => prev.slice(0, basePoints.length))
            setIDs(prev => prev.slice(0, basePoints.length));

            if (userID === null) {
                return;
            }

            const userPointsData = await fetchUserData(userID);
            if (!userPointsData) {
                return;
            }

            setUserPointsData(userPointsData);

            const formattedUserPoints = userPointsData.map(point => {
                let coordinates;
                switch (scatterPointsCategory) {
                    case 'tsne':
                        coordinates = point.t_sne_coordinates;
                        break;
                    case 'pca':
                        coordinates = point.PCA_coordinates;
                        break;
                    case 'umap':
                        coordinates = point.UMAP_coordinates;
                        break;
                    case 'geo':
                        coordinates = Array([0, 0]);
                    default:
                        coordinates = point.t_sne_coordinates;
                }
                return [coordinates.x_norm, coordinates.y_norm];
            });

            setUserPoints(formattedUserPoints);
            setSizes(prev => [...prev, ...Array(userPointsData.length).fill(1)]);
            setIDs(prev => [...prev, ...userPointsData.map(point => point.run_assembly_id)]);

        } catch (err) {
            setError('failed to fetch id data');
        }
    };


    useEffect(() => {
        fetchIdData();
        fetchTotalBiomeData(); // Fetch total biome counts once at startup
    }, []);


    useEffect(() => {
        fetchPointData(scatterPointsCategory);

    }, [scatterPointsCategory]);

    useEffect(() => {
        fetchColorData(scatterColorCategory);
    }, [scatterColorCategory]);


    useEffect(() => {
        fetchIdData();
    }, []);

    useEffect(() => {
        if (!loadingPoints && !loadingColor && !loadingIds) {
            fetchUserSampleData(userID, scatterPointsCategory);
        }

    }, [userID, scatterPointsCategory, loadingPoints, loadingColor, loadingIds]);

    useEffect(() => {
        if (hasUserSamples && scatterPointsCategory !== 'tsne') {
            setScatterPointsCategory('tsne');
        }
    }, [hasUserSamples, scatterPointsCategory]);


    const fetchTotalBiomeData = async () => {
        try {
            const totalCounts = await fetchTotalBiomeCounts();
            setTotalBiomeCounts(totalCounts);
        } catch (err) {
            console.error('Failed to fetch total biome counts:', err);
        }
    };

    useEffect(() => {
        let color_dict_possib;

        if (scatterColorCategory === "source_biome") {
            // if (!(continuousCategories.includes(scatterColorCategory))) {
            // console.log("colorsData", colorsData);

            color_dict_possib = produceBiomeColorDict(colorsData);
        }
        if (color_dict_possib) {
            setPossibleColorDict(color_dict_possib);
        }

    }, [colorsData, scatterColorCategory]);


    useEffect(() => {
        if (basePoints.length > 0) {
            setPoints([...basePoints, ...userPoints]);
            // console.log("points", points);
        }
    }, [basePoints, userPoints]);

    useEffect(() => {
        if (!colorsData || colorsData.length === 0) {
            return;
        }

        let categoriesSet = new Set(), color_dict = {}, colorsIndexList, userColorIndex;
        let baseColorsIndexList;
        const userPointsColors = Array(userPoints.length).fill(null);

        if (continuousCategories.includes(scatterColorCategory)) {
            [categoriesSet, color_dict, colorsIndexList] = arrayToContinuousNormalized(
                colorsData.slice(0, basePoints.length),
                scatterColorCategory,
                userPointsData ? userPointsData.map(d => d[scatterColorCategory]) : [],
                userColorMode // or null if not needed
            );
            baseColorsIndexList = colorsIndexList.slice(0, basePoints.length);
        } else if (scatterColorCategory === "source_biome") {
            [categoriesSet, color_dict, colorsIndexList] = arrayToColorDictSourceBiomeNiceColors(
                colorsData,
                colorParentSelected
            );
            baseColorsIndexList = colorsIndexList.slice(0, basePoints.length);
        } else {
            [categoriesSet, color_dict, colorsIndexList, userColorIndex] = arrayToColorDict(
                colorsData,
                scatterColorCategory
            );
            baseColorsIndexList = colorsIndexList.slice(0, basePoints.length);
        }

        if (userPoints.length > 0 && userPointsData) {
            const colorField = userColorMode === 'confidence' ? 'confidence_hex' : 'color_hex';

            userPoints.forEach((_, index) => {
                const globalIndex = basePoints.length + index;
                const userSample = ids[globalIndex];
                const userData = userPointsData?.find(d => d.run_assembly_id === userSample);

                if (userData && userData[colorField]) {
                    const rgb = hexToRgb(userData[colorField]);
                    if (rgb) {
                        const colorKey = `user_${userColorMode}_${userData[colorField]}`;

                        const existingColorIndex = Object.entries(color_dict).findIndex(
                            ([_, c]) => Array.isArray(c) && c[0] === rgb.r && c[1] === rgb.g && c[2] === rgb.b
                        );

                        if (existingColorIndex === -1) {
                            color_dict[colorKey] = [rgb.r, rgb.g, rgb.b];
                            userPointsColors[index] = Object.keys(color_dict).length - 1;
                        } else {
                            userPointsColors[index] = existingColorIndex;
                        }
                    } else {
                        if (!color_dict["__user__"]) {
                            color_dict["__user__"] = [128, 0, 128];
                        }
                        userPointsColors[index] = Object.keys(color_dict).indexOf("__user__");
                    }
                } else {
                    if (!color_dict["__user__"]) {
                        color_dict["__user__"] = [128, 0, 128];
                    }
                    userPointsColors[index] = Object.keys(color_dict).indexOf("__user__");
                }
            });
        }

        const fullColorsIndexList = [...baseColorsIndexList, ...userPointsColors.map(i => i ?? 0)];

        setColorDict({ ...color_dict });
        setColors(fullColorsIndexList);
        setUniqueCategories([...categoriesSet]);



        if (pendingSelection && scatterplot?.select) {
            const category = typeof pendingSelection === 'string' ? pendingSelection : pendingSelection.category;
            const includeUserPoints = typeof pendingSelection === 'string' ? false : pendingSelection.includeUserPoints;

            const selectedCategories = Object.keys(color_dict).filter(cat =>
                cat === category || cat.startsWith(category + ':')
            );

            const colorToCategory = Object.entries(color_dict).reduce((acc, [cat, col], idx) => {
                acc[idx] = cat;
                return acc;
            }, {});

            const pointColorIndexes = fullColorsIndexList.reduce((acc, colorIndex, pointIndex) => {
                const categoryForColor = colorToCategory[colorIndex];
                if (selectedCategories.includes(categoryForColor)) {
                    acc.push(pointIndex);
                }
                return acc;
            }, []);

            scatterplot.select(pointColorIndexes);
            setPendingSelection(null);
        }
    }, [colorsData, scatterColorCategory, colorParentSelected, catigoricalResolution, userPoints.length, pendingSelection, userPointsData, basePoints.length, ids, userColorMode]);

    useEffect(() => {
        if (isFirstVisit()) {
            setShowWelcomeInfo(true);
        }
    }, []);

    useEffect(() => {
    }, [historyPointsSelectionStack, futurePointsSelectionStack]);

    if (loading) {
        return <LoadingHome isLoading={loading} />;
        // <LoadingHome isLoading={true} />
    }

    if (error) {
        return <div>{error}</div>;
    }

    const updateHistoryStack = (prevSelection) => {
        // console.log("updateHistoryStack");

        if (prevSelection && prevSelection !== currentPointsSelection) {
            setHistoryPointsSelectionStack((prev) => [...prev, prevSelection]);
            setFuturePointsSelectionStack([]);
        }
    };




    return (
        <>
            <LoadingHome isLoading={loading} />
            <InfoComponent
                isOpen={showWelcomeInfo}
                onClose={() => setShowWelcomeInfo(false)}
            />
            <TopLeftMenuSimple
                scatterplot={scatterplot}
                setScatterPointsCategory={setScatterPointsCategory}
                scatterPointsCategory={scatterPointsCategory}
                setScatterColorCategory={setScatterColorCategory}
                scatterColorCategory={scatterColorCategory}
                ids={ids}
                historyPointsSelectionStack={historyPointsSelectionStack}
                setHistoryPointsSelectionStack={setHistoryPointsSelectionStack}
                futurePointsSelectionStack={futurePointsSelectionStack}
                setFuturePointsSelectionStack={setFuturePointsSelectionStack}
                currentPointsSelection={currentPointsSelection}
                setCurrentPointsSelection={setCurrentPointsSelection}
                isHistoryNavigationRef={isHistoryNavigationRef}
                setUserID={setUserID}
                setHighlightTaxon={setHighlightTaxon}
                hasUserSamples={hasUserSamples}
                basePoints={basePoints}
            />
            <TopRightMenu
                scatterplot={scatterplot}
                selectedSampleInfo={selectedSampleInfo}
                possibleColorDict={possibleColorDict}
                highlightTaxon={highlightTaxon}
                setHighlightTaxon={setHighlightTaxon}
                colors={colors}
                points={points}
                ids={ids}
                currentPointsSelection={currentPointsSelection}
                totalBiomeCounts={totalBiomeCounts}
            />
            <Legends
                // common props
                scatterColorCategory={scatterColorCategory}
                scatterplot={scatterplot}
                colorDict={colorDict}
                colors={colors}

                // hierarchy specific
                uniqueCategories={uniqueCategories}
                colorParentSelected={colorParentSelected}
                setColorParentSelected={setColorParentSelected}
                possibleColorDict={possibleColorDict}
                setPendingSelection={setPendingSelection}

                // continuous specific  
                values={colorsData}

                // regular specific
                setCatigoricalResolution={setCatigoricalResolution}

                loadingColor={loadingColor}
                continuousCategories={continuousCategories}
                ids={ids}
            />
            {hasUserSamples && userPointsData && (
                <UserLegend
                    userPointsData={userPointsData}
                    scatterplot={scatterplot}
                    basePoints={basePoints}
                    scatterColorCategory={scatterColorCategory}
                    setUserColorMode={setUserColorMode}
                />
            )}
            {/* <PointHover
                isVisible={hoverVisible}
                position={hoverPosition}
                pointData={hoverPointData}
                possibleColorDict={possibleColorDict}
                centerBottom={true}

            /> */}
            <Scatterplot
                points={points}
                ids={ids}
                colors={colors}
                sizes={sizes}

                colorDict={colorDict}

                scatterPointsCategory={scatterPointsCategory}
                scatterColorCategory={scatterColorCategory}

                setScatterplot={setScatterplot}

                setHoveredSampleInfo={setHoveredSampleInfo}
                setSelectedSampleInfo={setSelectedSampleInfo}

                currentPointsSelection={currentPointsSelection}
                updateHistoryStack={updateHistoryStack}

                possibleColorDict={possibleColorDict}
                colorsData={colorsData}
                setHoverVisible={setHoverVisible}
                setHoverPointData={setHoverPointData}

                isHistoryNavigationRef={isHistoryNavigationRef}
            />
            {scatterplot && (
                scatterPointsCategory === 'tsne' &&
                <LabelOverlay
                    scatterplot={scatterplot}
                    fontSize={12}
                />
            )}
        </>
    );
}

export default Home;

const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};
